import { Button, DeleteIcon, Menu, MoreIcon, StopIcon, TransferIcon } from "melco-ui";
import { Dropdown } from "antd";
import { useTranslation } from "react-i18next";
import {
    ControlcenterMelcoModelsThreadChart,
    // Drawer as DrawerType,
    // MelcoModelsUserSerialNumber,
    useConfirm,
} from "melco-shared-logic";
//import { useRolesContext } from "../../hooks/roles/useRolesContext";
import { useNavigate } from "react-router-dom";
import { useDeleteThread } from "../../hooks/threads/useDeleteThread";

type ThreadMoreActionButtonProps = {

    thread?: ControlcenterMelcoModelsThreadChart | undefined;
};

export const ThreadMoreActionButton: React.FC<
    ThreadMoreActionButtonProps
> = ({ thread }) => {
    const { t } = useTranslation();

    const navigate = useNavigate()
    // const { roles } = useRolesContext();
    const deleteThread = useDeleteThread(thread?.id ?? undefined);
    const confirmDeleteThread = useConfirm(
        async () => {


            const deleteThreadResponse = await deleteThread();

            // redirect to list view 
            if (deleteThreadResponse.success) {
                navigate(`/system/managethreads`);
            }

        },
        {
            translationPrefix: "managethreads.actions.delete",

        }
    );

    /**
     * make sure button should show only for version 2 threads
     */
    const MoreActions = (
        <Menu>
            {thread?.version === 2 && (
                <Menu.Item
                    key="more-actions-delete"
                    onClick={async () => { await confirmDeleteThread() }}
                    icon={<DeleteIcon />}
                >
                    {t("managethreads.actions.delete.button.title")}
                </Menu.Item>
            )}


        </Menu >
    );

    return (
        <Dropdown
            overlay={MoreActions}
            trigger={["click"]}
            placement="bottomRight"
            arrow
        >
            <Button
                key="thread-more-actions"
                icon={<MoreIcon />}
                data-cy-id="thread-more-actions"
            />
        </Dropdown>
    );
};
